import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import {
  interventionCenterFirstForms,
  interventionCenterSecondForms,
  interventionCenterThirdForms,
} from './interventionCenterForms';
import type { Client } from '../../../../common/types/client';
import ListItemField from '../../../../common/components/ListItemField';
import measureForm from '../measure/measureForm';
import MeasureRow from '../measure/MeasureRow';
import FormWrapper from '../../../../common/components/FormWrapper';
import FaxRow from '../fax/FaxRow';
import faxForm from '../fax/faxForm';
import contactAttemptForm from '../contactAttempts/contactAttemptForm';
import ContactAttemptRow from '../contactAttempts/ContactAttemptRow';
import MoveClientToCounselingCenter from './MoveClientToCounselingCenter';

type Props = {
  client: Client;
  updateClient: (client: Client) => void;
  saveClient?: (client: Client) => void;
};

function InterventionCenterClientForm({ client, updateClient, saveClient }: Props) {
  return (
    <Stack id='test' px={3} pt={1} pb={2} overflow='auto scroll'>
      <Box component='form' noValidate autoComplete='off' maxWidth='650px'>
        {interventionCenterFirstForms.map((form) => (
          <FormWrapper key={form.key} form={form} item={client} update={updateClient} save={saveClient} />
        ))}
        <ListItemField
          items={client.faxes || []}
          headline='Fax'
          margin={5}
          itemForm={faxForm}
          renderItemRow={(item, itemForm) => <FaxRow fax={item} itemForm={itemForm} />}
          handleSave={(value) => {
            if (saveClient !== null && saveClient !== undefined) {
              saveClient({
                ...client,
                faxes: value,
              });
            }
          }}
          handleChange={(value) => {
            updateClient({
              ...client,
              faxes: value,
            });
          }}
        />
        {interventionCenterSecondForms.map((form) => (
          <FormWrapper key={form.key} form={form} item={client} update={updateClient} save={saveClient} />
        ))}
        <ListItemField
          items={client.contactAttempts || []}
          headline='Kurzkontakte'
          margin={5}
          itemForm={contactAttemptForm}
          renderItemRow={(item, itemForm) => <ContactAttemptRow contactAttempt={item} itemForm={itemForm} />}
          handleSave={(value) => {
            if (saveClient !== null && saveClient !== undefined) {
              saveClient({
                ...client,
                contactAttempts: value,
              });
            }
          }}
          handleChange={(value) => {
            updateClient({
              ...client,
              contactAttempts: value,
            });
          }}
        />
        <ListItemField
          items={client.measures || []}
          headline='Beratung'
          margin={5}
          preallocateItem={{
            label: 'Telefonische Beratung',
            value: {
              type: 'telephoneConsultation',
              topic: ['domesticViolence'],
              duration: 59,
            },
          }}
          itemForm={measureForm}
          renderItemRow={(item, itemForm) => <MeasureRow measure={item} itemForm={itemForm} />}
          handleSave={(value) => {
            if (saveClient !== null && saveClient !== undefined) {
              saveClient({
                ...client,
                measures: value,
              });
            }
          }}
          handleChange={(value) => {
            updateClient({
              ...client,
              measures: value,
            });
          }}
        />
        <MoveClientToCounselingCenter item={client} update={updateClient} save={saveClient} />
        {interventionCenterThirdForms.map((form) => (
          <FormWrapper key={form.key} form={form} item={client} update={updateClient} save={saveClient} />
        ))}
      </Box>
    </Stack>
  );
}

export default InterventionCenterClientForm;
